import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'portals-audio-video-bar',
	templateUrl: './audio-video-bar.component.html',
	styleUrls: ['./audio-video-bar.component.scss'],
})
export class AudioVideoBarComponent implements OnInit {
	@Input() data!: { video: number; audio: number; text: number };

	positiveWidth: number = 0;
	negativeWidth: number = 0;
	neutralWidth: number = 0;
	getTotal() {
		return this.data.video + this.data.audio + this.data.text;
	}
	ngOnInit() {
		if (this.data) {
			const total = this.data.video + this.data.audio + this.data.text;
			this.positiveWidth = (this.data.video / total) * 100;
			this.negativeWidth = (this.data.audio / total) * 100;
			this.neutralWidth = (this.data.text / total) * 100;
		}
	}
}
